import { useContext } from "react";

import MobileLayoutContext from "../context/MobileLayoutContext";

export default function useMobileLayout() {
    return useContext(MobileLayoutContext);
}
